import request from '@/utils/request'

/**
 * 获取角色列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getRolesList(params) {
  return request({
    url: '/Roles',
    method: 'get',
    params
  })
}

/**
 * 获取角色详情
 * @param {Number} id - 角色ID
 * @returns {Promise}
 */
export function getRoleById(id) {
  return request({
    url: `/Roles/${id}`,
    method: 'get'
  })
}

/**
 * 创建角色
 * @param {Object} data - 角色数据 {role_name, is_system, description, creator_id}
 * @returns {Promise}
 */
export function createRole(data) {
  return request({
    url: '/Roles',
    method: 'post',
    data
  })
}

/**
 * 更新角色
 * @param {Number} id - 角色ID
 * @param {Object} data - 角色数据 {role_name, is_system, description}
 * @returns {Promise}
 */
export function updateRole(id, data) {
  return request({
    url: `/Roles/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除角色
 * @param {Number} id - 角色ID
 * @returns {Promise}
 */
export function deleteRole(id) {
  return request({
    url: `/Roles/${id}`,
    method: 'delete'
  })
}

/**
 * 获取权限树形菜单
 * @returns {Promise}
 */
export function getPermissionsTree() {
  return request({
    url: '/permissions/tree',
    method: 'get'
  })
}

/**
 * 获取角色的权限
 * @param {Number} roleId - 角色ID
 * @returns {Promise}
 */
export function getRolePermissions(roleId) {
  return request({
    url: `/Roles/${roleId}/permissions`,
    method: 'get'
  })
}

/**
 * 分配角色权限
 * @param {Number} roleId - 角色ID
 * @param {Array} permissionIds - 权限ID数组
 * @returns {Promise}
 */
export function assignRolePermissions(roleId, permissionIds) {
  return request({
    url: `/Roles/${roleId}/permissions`,
    method: 'post',
    data: { permissions: permissionIds }
  })
}

/**
 * 绑定模型
 * @param {Number} id - 角色ID
 * @param {Object} data - 角色数据 {role_name, is_system, description}
 * @returns {Promise}
 */
export function bindModel(id, data) {
  return request({
    url: `/role/bindModel/${id}`,
    method: 'put',
    data
  })
}
